<template>
	<v-container>
		<v-layout >
			
			<v-card>
				<v-card-title primary-title class=" text-uppercase">
					Short Bio
				</v-card-title>
				<v-card-text>

<p>
	Steven Noyce recently received his PhD in Electrical and Computer Engineering from Duke University.  Steven’s passion for discovery triggered the beginning of his research career synthesizing carbon nanotubes in a high school chemistry lab.  This work facilitated connections with the university lab of Robert Davis, where Steven did research while earning his B.S. degree in physics, minoring in computer science.  Projects in this lab included developing resonant chemical sensors with extremely high surface areas, developing self-assembled circuits using carbon nanotubes and DNA origami, and building high aspect ratio microelectromechanical systems using metal electroplating.  During an internship at Cornell University Steven worked on developing a solid state nanopore DNA sequencer, with the result being spun out into a company: Esper Biosciences.
</p>
<p>
	In his graduate work, Steven focused on building sensors from nanomaterial transistors and determining how these nanomaterials respond to local charge perturbations, changes in environment, etc.  This work has spanned many materials including carbon nanotubes, silicon nanowires, and 2D materials such as molybdenum disulfide, while fabrication strategies involved have ranged from traditional clean room approaches to electronics printing.  Each of these studies has produced sensor optimization insights that allow for large improvements in nanomaterial-based biosensors, ultimately contributing to low-cost and high-precision medical diagnoses.
</p>
<p>
	In previous work, Steven was a founder and the Director of Engineering for <a href="http://cattleguard.com/">CattleGuard</a>, a startup focused on using Internet of Things technology to improve agricultural efficiency.
</p>
<p>
	Currently, Steven is a Senior Scientist at <a href="https://tyrata.com/">Tyrata</a>, a startup company spun out of his lab at Duke that develops sensors for tracking tire tread, with the goal of reducing the number of lives lost annually to accidents attributable to bad tires, while improving efficiency of both commercial fleets and consumer vehicles by building intelligence into tires.
</p>
<p>
	Additionally, Steven serves as the CEO of <a href="https://versametrics.com">Versametrics</a>, a startup extending work done by Steven during his PhD research by developing versatile and automated electrical measurement systems.
</p>
<p>
	Outside of work, Steven enjoys rock climbing, spending time outdoors with family, playing the cello, tinkering with circuits, and toying with machine learning.  Additionally, Steven gets a thrill out of seeking to ignite a spark of discovery and exploration in his wife and two children.
</p>
					
				</v-card-text>
			</v-card>
			
		</v-layout>
	</v-container>
</template>

<script>
	export default {
		data: () => ({
			//
		})
	}
</script>

